import "./ShapeTwo.css";

export default function ShapeTwo() {
  return (
    <div className="shape-2">
      <p>
        <span>press </span>
        <br></br>the smiley<br></br> <span>star</span>
      </p>
    </div>
  );
}
